import React from 'react';

const Client = ({client}) => {
    const {image} = client;

    return (
        <div className="brand-logo">
            <div className="brand-logo-inner">
                <img src={image} alt="Clients"/>
            </div>
        </div>
    );
};


export default Client;


// WEBPACK FOOTER //
// ./app/routes/extraPages/routes/aboutUs/Componets/Client.js